// import DownloadIcons from "../../assets/icons/download.svg";
import { DownloadIcon } from "../../assets/svgs/DownloadIcon";

type HistoryHeaderProps = {
  title: string;
  openFilter: () => void;
  downloadFn: () => void;
};
export const HistoryHeader: React.FC<HistoryHeaderProps> = (props) => {
  const { title, openFilter, downloadFn } = props;

  return (
    <header>
      <div className="header tw-flex tw-flex-col tw-gap-[1em] tw-mt-[1.5em]">
        <div className="tw-w-full tw-flex tw-items-end tw-justify-between tw-pb-[2em]">
          <h1 className="text-header-5 title tw-font-[600] tw-text-neutral-900">
            {title}
          </h1>

          <div className="tw-w-fit tw-flex tw-gap-[1em]">
            <div
              onClick={openFilter}
              className="tw-bg-transparent tw-cursor-pointer tw-w-fit tw-h-[48px] tw-border tw-border-neutral-300 tw-rounded-[8px] tw-flex tw-items-center tw-justify-center tw-gap-[5px] tw-text-[1em] tw-font-[600] tw-text-neutral-900 tw-px-[1.5em] tw-py-[1em]"
            >
              {/* <img src={DownloadIcons} alt="dowload" />{" "} */}
              {/* <DownloadIcon /> */}
              <p className="tw-text-neutral-900 tw-font-[300] tw-whitespace-nowrap">
                Filter
              </p>{" "}
            </div>

            <div
              onClick={downloadFn}
              className="tw-bg-transparent tw-cursor-pointer tw-w-fit tw-h-[48px] tw-border tw-border-neutral-300 tw-rounded-[8px] tw-flex tw-items-center tw-justify-center tw-gap-[5px] tw-text-[1em] tw-font-[600] tw-text-neutral-900 tw-px-[1.5em] tw-py-[1em]"
            >
              {/* <img src={DownloadIcon} alt="dowload" />  */}
              <DownloadIcon />
              <p className="tw-text-neutral-900 tw-font-[300] tw-whitespace-nowrap">
                Download Report
              </p>{" "}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
